import { __ } from '@wordpress/i18n';

const removeMarketoFormStyles = (formEl) => {
	// Remove Marketo's external stylesheet injected into <head>
	document.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
		if (link.href && link.href.includes('forms2')) {
			link.remove();
		}
	});

	// Remove the <style> block Marketo injects inside the <form> element
	const injectedStyle = formEl.querySelector('style');

	if (injectedStyle) {
		injectedStyle.remove();
	}

	// Strip inline style attributes so theme CSS takes over
	formEl.removeAttribute('style');

	formEl.querySelectorAll('[style]').forEach((el) => {
		el.removeAttribute('style');
	});
};

const adjustMarketoForms = (formEl) => {
	const requiredAsterisks = formEl.querySelectorAll('.mktoAsterix');

	if (requiredAsterisks.length > 0) {
		requiredAsterisks.forEach((requiredAsterisk) => {
			const requiredText = document.createElement('span');
			requiredText.innerText = __('(Required)', 'propel');
			requiredText.classList.add('sr-only');

			requiredAsterisk.appendChild(requiredText);
		});
	}
};

const initMarketoForms = () => {
	if (!window.MktoForms2) {
		return;
	}

	window.MktoForms2.whenReady((form) => {
		const formEl = form.getFormElem()[0];

		if (!formEl) {
			return;
		}

		removeMarketoFormStyles(formEl);
		adjustMarketoForms(formEl);
	});
};

initMarketoForms();
